export default function Footer() {
  return (
    <div className="wrapper">
      <section className="footer">
        <p>Copyright @2025 Ugly Chairs</p>
      </section>
    </div>
  );
}
